import { writable } from "svelte/store";
const ss_key = import.meta.env.VITE_SESSION_STORE_KEY;

const Store = () => {
  const { subscribe, update } = writable<string>(
    sessionStorage.getItem(ss_key)
  );

  // 作成
  const regist = (value: string) => {
    update((prev) => value);

    sessionStorage.setItem(ss_key, value);
  };
  return { subscribe, regist };
};

export const authStore = Store();
